import { getAssetBase } from "./fetcher";

const getImage = (path, parent = "/image/") => `${getAssetBase()}${parent}${path}`;

/** URL превью обложки каталога (400x300 WebP), совпадает с форматом бэкенда */
const getCatalogCardWebpUrl = (path) =>
  `${getAssetBase()}/image/cache/${path.replace(/\.[^.]+$/, '')}-400x300.webp`;

const menuFlatter = (categories = []) => {
  const flat = [];
  categories.forEach(({ children, ...rest }) => {
    flat.push(rest);
    children?.forEach(({ children, ...rest }) => {
      flat.push(rest);
      children?.forEach((cat3) => {
        flat.push(cat3);
      });
    });
  });
  return flat;
};

export {
  getImage,
  getCatalogCardWebpUrl,
  menuFlatter,
};
